module.exports = __webpack_public_path__ + "static/media/20210403_200526_119_IMG_0006.63041d39.jpg";